import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import AddUser from './AddUser'
import EditUser from './EditUser'
import ViewUser from './ViewUser'
import reactStringReplace from 'react-string-replace'
import * as Icons from "react-feather";
import DeleteUser from './DeleteUser'
import UserModel from './models/UserModel'
import ResetUserPassword from './ResetUserPassword'

function UserModal({onClose, onSubmit, UserAction, show, selectedRow}) {
    const [childData, setChildData] = useState(new UserModel() || []);
    let modalAction;
    let showButtons;
    let userAction = reactStringReplace(UserAction, 'User', () => '');
        function getSafeUserData(row) {
                const defaultUser = new UserModel();
                return { ...defaultUser, ...(row || {}) };
        }

        useEffect(() => {
                if (show && selectedRow) {
                    setChildData(getSafeUserData(selectedRow)); // merge defaults with selectedRow
                } else if (!show) {
                    setChildData(new UserModel()); // reset when closed
                }
        }, [selectedRow, show]);

    const handleDataFromChild = (data) => {
        setChildData(data);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e, childData);  // Send the form data back to the parent component
    };

    const handleLoad = (data) => {
        setChildData(data); // Send the form data back to the parent component
    };
    const handleCancel = (label) => {
      onClose();
    };
    if(UserAction === "AddUser"){
        modalAction = <AddUser  onLoad= {handleLoad} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="AddUser" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="AddUser" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "EditUser"){
        modalAction = <EditUser UserData={childData} onSubmit= {onSubmit} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="EditUser" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="EditUser" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "ViewUser"){
        modalAction = <ViewUser UserData={childData}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="ViewUser" onClick={onClose}>Cancel</button>
                    </div>
    } else if(UserAction === "DeleteUser"){
        modalAction = <DeleteUser UserData={childData}/>
        showButtons = <div>
                            <button className="btn btn-sm btn-secondary m-1" name="DeleteUser" onClick={onClose}>Cancel</button>
                            <button className="btn btn-sm btn-danger m-1" name="DeleteUser" onClick={onSubmit}>Delete</button>
                    </div>
    } else if(UserAction === "ResetPassword"){
        modalAction = <ResetUserPassword UserData={childData} sendDataToParent={handleDataFromChild}/>
        showButtons =   <div>
                            <button className="btn btn-cancel me-2" name="ResetPassword" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="ResetPassword" onClick={handleSubmit}>Reset Password</button>
                        </div>
    }

    return (
        UserAction !== "DeleteUser" &&  UserAction !== "ResetPassword" ?
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
            >
                <ModalHeader className="modal-header border-0 custom-modal-header">
                    <ModalTitle >{userAction} User</ModalTitle>
                <button type="button" className="close" aria-label="Close" onClick={() => handleCancel('Close')}>
                        <span aria-hidden="true">×</span>
                    </button>
                </ModalHeader>
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="">
                    {showButtons}
                </ModalFooter>
            </Modal> 
        : UserAction === "ResetPassword" ?
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
            >
                <ModalHeader className="modal-header border-0 custom-modal-header" closeButton>
                    <ModalTitle >Reset User Password </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="">
                    {showButtons}
                </ModalFooter>
            </Modal> 
            : <Modal
                show={show}
                onHide={onClose}
                backdrop="static"            >
           
                <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
                    <ModalTitle>
                        <div className="custom-alert-icon">
                            <Icons.AlertOctagon className="flex-shrink-0"/>
                        </div>
                        <div > {userAction} User</div>
                    </ModalTitle>
                </ModalHeader>
                
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="modalfooter-width">
                    {showButtons}
                </ModalFooter>
            </Modal>   
    )
}

export default UserModal